// extracted by css-extract-rspack-plugin
export default {"switch":"kYsQL7tADj8U4LwB","slider":"MW9RpD3maAP8huv0"};